import type { EntityID } from "./three-d-schemas";

export {
  threeDPanelConfigSchema,
  threeDPanelDataSchema,
  type Camera,
  type OrbitCamera,
  type PanelData,
  type PanelConfig,
  type Path,
  type PositionTransformation,
  type PositionBasePreset,
  type Position,
  type Sphere,
  type Box,
  type Mesh,
  type VectorFieldDisplayMode,
  type VectorField,
  type Grid,
  type Entity,
  type EntityID,
} from "./three-d-schemas";

export const DEFAULT_ENTITY_ID: EntityID = "entity0";
